import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CodelistTranslationService {

  private codelistTranslations: any = {};
  readonly NAMESPACE_SEPARATOR = '::';
  readonly CODELIST_TRANSLATIONS_BASE_PATH = 'assets/codelists/';
  readonly CODELIST_TRANSLATIONS_FILE_PREFIX = 'codelists_';

  constructor(
    private http: HttpClient
  ) {}

  public translateCodelistItem(ns:string, key:string):string {
    return this.codelistTranslations[`${ns}${this.NAMESPACE_SEPARATOR}${key}`] ?? key;
  }

  public translateCodelistItemByNSArray(ns: string[], key: string): string {
    for (const namespace of ns) {
      if (this.codelistTranslations[`${namespace}${this.NAMESPACE_SEPARATOR}${key}`]) {
        return this.translateCodelistItem(namespace, key);
      }
    }
    return key;
  }

  public loadCodelistTranslations(locale: string): void {
    this.http.get(`${this.CODELIST_TRANSLATIONS_BASE_PATH}${this.CODELIST_TRANSLATIONS_FILE_PREFIX}${locale}.json`)
      .subscribe((codelists) => {
        this.codelistTranslations = codelists;
      });
  }

  get erechnungPrefix(): string {
    return $localize`:@@einvoice.technical.labels.erechnung-prefix:eRechnung` + ' ';
  }
}
